import styled from 'styled-components'

export const ProgressContainer = styled.div`
  padding:2%;
  background-color:#ecf0f1;
`;

export const AboutContainer = styled.div`
    padding:2%;
`;



// WEBPACK FOOTER //
// ./src/Raytracer/Raytracer.style.js